import { Component, OnInit } from '@angular/core';
import { FoldersViewController } from '@commoncore/controller/FoldersViewController';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { ListViewImplementation } from '@commoncore/implementation/ListViewImplementation';
import { ContextMenuMobileService } from '@commoncore/services/context-menu-mobile.service';
import { GlobalService } from '@commoncore/services/global.service';
import { UniversalService } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { AllFilesController } from '@mainrepo/app/core/controller/AllFilesController';
import { SharedFilesListController } from '@mainrepo/app/core/controller/SharedFilesListController';

@Component({
  selector: 'lib-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {
  route: any;
  listService: any;
  folderService: any;
  router: any;
  contextMenuService: any;
  listImpl: any;
  controller:any;
  implRef:any;
  viewObject:any=null;
  localStorageService:any;
  sessionStorageService: any;
  constructor(
    public globalService:GlobalService,
    public universalService: UniversalService,
    public contextMenuMobileService:ContextMenuMobileService) { 
      this.setDependencies(globalService)
  }

  ngOnInit(): void {

    AppEvents.toastMessageEvent.subscribe(event => {
      if(event["action"] == "view"){
        this.viewObject = event["data"];
      }
    })
  }

  setDependencies(globalService) {
    this.route = globalService.getActivatedRoute();
    this.listService = globalService.getListServiceRef();
    this.folderService = globalService.getFolderServiceRef();
    this.router = globalService.getRouterRef()
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.listService = globalService.getListServiceRef();
    this.listImpl = ListViewImplementation.getInstance(globalService)
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
  }

  viewFile() {
    this.universalService.operationInProgress = true;
    //Clear previous selection on upload view
    if(this.universalService.viewButtonUrl != ""){
      var url = this.universalService.viewButtonUrl;
      this.universalService.viewButtonUrl = "";
      window.open(url, "_blank", "noopener, noreferrer");
      this.universalService.operationInProgress = false;
      return
    } 
    var redirect = (this.router.url.includes(this.viewObject["uploadedFolderKey"]) || (this.viewObject["uploadedFolderKey"] == USER_DETAILS["USER_DETAILS"]["rootFolderKey"] && this.router.url == "/allfiles")  ) ? false : true;  // rewriting the same logic from upload implementation, to hanlde the scenario is the user keeps switching after the toast msg is shown
    var object = {
      "redirectUser": redirect,
      "selectObjects": redirect ? false : true,
      "redirectFolderKey": redirect ? this.viewObject["redirectFolderKey"] : USER_DETAILS["USER_DETAILS"]["rootFolderKey"],
      "locationOfUpload":this.viewObject["locationOfUpload"]
    }
    this.viewObject = object;
    jQuery(".tab-content").find(".grid_info").removeClass("grid_info");
    jQuery(".tab-content").find(".list_info").removeClass("list_info");
    this.universalService.showSuccessToastMessage = false;
    if(this.viewObject && this.viewObject["redirectUser"] && this.viewObject["redirectFolderKey"] != ""){
      if(this.viewObject["locationOfUpload"].includes('sharedbyme')){
        this.controller = SharedFilesListController.getInstance(this.globalService);
        this.router.navigate(['/shared/sharedbyme', this.viewObject["redirectFolderKey"]]);
      }else if (this.viewObject["locationOfUpload"].includes('sharedwithme') && this.universalService.allowUpload){
        this.controller = SharedFilesListController.getInstance(this.globalService);
        this.router.navigate(['/shared/sharedwithme', this.viewObject["redirectFolderKey"]]);
      }else if (this.viewObject["locationOfUpload"].includes('album')){
        this.universalService.currentTab = "";
        this.router.navigate(['/albums/myalbums', this.viewObject["redirectFolderKey"]]);
      }else{
        this.controller = AllFilesController.getInstance(this.globalService);
        if(this.viewObject["redirectFolderKey"] == USER_DETAILS["USER_DETAILS"]["rootFolderKey"]){
          this.universalService.openFolderContent = false;
          this.folderService.initialiseBreadCrumbs('1', this.universalService.rootFolderNameNew, null);
          AppEvents.emit(EventsList.MYFILES_TABBED_VIEW);
        }else{
          AppEvents.emit(EventsList.EMPTY_TABBED_VIEW);
          this.folderService.manageBreadCrumbs(null,null,null,true);
        }
        this.router.navigate(['/allfiles',this.viewObject["redirectFolderKey"]]);
      }
      if(!this.viewObject["locationOfUpload"].includes("album") && this.viewObject["redirectFolderKey"] != USER_DETAILS["USER_DETAILS"]["rootFolderKey"]){
        this.universalService.selectedFile = JSON.parse(this.localStorageService.getFolderDataInWhichUploadIsInitiated());
        if(!this.universalService.openFolderContent){
          this.universalService.openFolderContent = true;
        }else{
          AppEvents.globalObservable.next({'open':true,"object":this.universalService.selectedFile,"objectName":this.universalService.selectedFile["objectName"]})
        }
       
      }
        this.viewObject = null;
        this.localStorageService.removeLocalProperty(LocalStorageProps.UPLOAD_INITIATED_FOLDER);
        return
    }
    var contextMenuRef = this.contextMenuService;
    const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    let currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
    if(this.router.url.includes('teamfolders') && this.universalService.allowUpload) {
      currentFolderKey = this.sessionStorageService.getNestedTeamFolderkey();
    }
    var newObjectArray = [];
    currentFolderKey = currentFolderKey ? currentFolderKey : rootFolderKey;
    this.universalService.MarkNewObjArray.map((obj,index)=>{ // this is added if the folder is uploaded and on click of view button, only folder is getting selected and count is shown including the objects inside the folder
      if(obj["parentObjectKey"] == currentFolderKey){
          newObjectArray.push(obj)
      }
    })
    this.universalService.MarkNewObjArray = newObjectArray;
    if(this.universalService.MarkNewObjArray.length>=1 && (!this.universalService.listView && !this.universalService.isMobileDevice)){
      this.universalService.selectedNodes = [...this.universalService.MarkNewObjArray];
      if(this.universalService.MarkNewObjArray.length == 1) {
        this.universalService.selectedFile = this.universalService.MarkNewObjArray[0];
      }
      let target = this.universalService.selectedNodes[0].objectKey;
      contextMenuRef.decideContextMenuItemsForDesktop();   
      this.universalService.showTopMenuOptions();  
      let ele = document.querySelectorAll('.gridItem')
      this.universalService.selectedNodes.forEach(obj => {
        ele.forEach(item =>{
          if(obj.objectKey == item.id){
            this.universalService.showTopMenu = true; 
            item.classList.add('grid_info');
          }
        })
      });
      this.universalService.selectedFile = this.universalService.selectedNodes[0]

      let element = document.querySelectorAll("[id='"+target+"']")
      this.checkIfWeNeedToExpandFolderSection();
      
      if(element != null) {
        setTimeout(() => {
          element[element.length-1]?.scrollIntoView();
        }, 10);
       
      } else {
        this.universalService.hideTopMenuOptions();
      }
      AppEvents.virtualDOMObservable.next({"selectUploadedObjects":true,"objectList":this.universalService.MarkNewObjArray})
      this.universalService.MarkNewObjArray = [];
    }else if(this.universalService.MarkNewObjArray.length>=1 && (this.universalService.listView && !this.universalService.isMobileDevice)){
      setTimeout(()=>{
        // this.universalService.selectedRowAfterUpload.map(index=>{
        //   let rowNode = this.listService.listOptions.api.getDisplayedRowAtIndex(index);
        //   rowNode.setSelected(true);
        //   this.universalService.showTopMenu = true; 
        // })
        var indexes = [];
        this.universalService.MarkNewObjArray.map(obj=>{
          var find = this.universalService.allNodesDataFromListView.find(node=>node["data"]["objectId"] == obj["objectKey"]);
          if(find){
            var idx = this.universalService.allNodesDataFromListView.indexOf(find);
            if(idx != -1){
              indexes.push(idx)
            }
          }
        })
        indexes.map(idx=>{
          let rowNode = this.listService.listOptions.api.getDisplayedRowAtIndex(idx);
          rowNode.setSelected(true);
          this.universalService.showTopMenu = true; 
        })
        this.checkIfWeNeedToExpandFolderSection();
        this.universalService.MarkNewObjArray = [];
        this.universalService.selectedRowAfterUpload =[];
        setTimeout(()=>{
        this.universalService.isViewFileClicked = true;
        this.listService.listOptions.api.ensureIndexVisible(this.universalService.slectedRowId);
        var selectedRows = document.querySelectorAll('.ag-center-cols-clipper .ag-row-selected')
        selectedRows[0].scrollIntoView(); // scroll to selected
        },100)  
      },800)
    }else if(this.universalService.MarkNewObjArray.length>=1 && this.universalService.isMobileDevice){
      this.universalService.mobileSelectionModeOn = true;
      this.universalService.selectedNodes = [...this.universalService.MarkNewObjArray];
      if(this.universalService.MarkNewObjArray.length == 1) {
        this.universalService.selectedFile = this.universalService.MarkNewObjArray[0];
      }
      let target = this.universalService.selectedNodes[0].objectKey;
      this.contextMenuService.decideContextMenuItems();   
      // this.universalService.showTopMenu = true; 
      let ele;
      if(this.universalService.listView){
        ele = document.querySelectorAll('.listItem')
      }else{
        ele = document.querySelectorAll('.gridItem')
      }
      this.universalService.selectedNodes.forEach(obj => {
        ele.forEach(item =>{
          if(obj.objectKey == item.id){
            if(this.universalService.listView){
              item.classList.add('list_info');
            }else{
              item.classList.add('grid_info');
            }  
          }
        })
      });
      this.universalService.selectedFile = this.universalService.selectedNodes[0]
      let element = document.querySelectorAll("#"+target)
      if(element != null) {
        setTimeout(() => {
          element[element.length-1].scrollIntoView();
        }, 10);
      } else {
        this.universalService.hideTopMenuOptions();
      }
      this.checkIfWeNeedToExpandFolderSection();
      this.universalService.MarkNewObjArray = [];
    }
    setTimeout(() => {
      this.universalService.operationInProgress = false;
    }, 1000);
  }

  checkIfWeNeedToExpandFolderSection(){
    this.controller=FoldersViewController.getInstance(this.globalService)
    this.implRef = this.controller.folderViewImplementation;
    var found = this.universalService.MarkNewObjArray.find(obj=>(obj["FullObject"]?obj["FullObject"]["objectType"]:obj["objectType"]) == "FR")
    if(found){
      var objIndex = -1;
      this.universalService.foldersArray.filter(function(obj,index){
        if(obj["objectKey"] == found["objectKey"]){
          objIndex = index
          return false;
        }
      });
      if(objIndex >= 11){
        this.implRef.folderShownCount = this.universalService.foldersArray.length;
      }
    }
  }

  closeToast(name){
    if(name == "error")
      this.universalService.showErrorToastMessage = false;
    else if( name == "success")
      this.universalService.showSuccessToastMessage = false;

  }
}
